/* sb-dc-refit.js - refits the design to the new board every time the size
   changes, keeping its proportions.

   Three reports, 2026-09-02
   -------------------------
   1. A screen recording: an 8x8 political template switched to 10x3 came out
      stretched - flag artwork and photo box squashed flat, letters wide and
      thin.
   2. A screenshot: after several size changes the whole template had shrunk
      to a stamp in the middle of a 10ft board, smaller each time.
   3. A screenshot: a square flag template on a 10x3 board sat as a square in
      the middle with white either side. Wanted: fill the chosen size, in
      proportion, even if that means the top and bottom of the artwork are
      cut off.

   1 and 2 come from window.__dcRefit in sb-dc-aug.js. It scaled x and width by
   sx = newW/oldW and y and height by sy = newH/oldH - two different factors,
   so shapes and text were distorted by any change of aspect ratio - while
   images were scaled by min(sx, sy) instead. min is never bigger than 1 when
   either side shrinks, and nothing ever scales the design back up, so every
   change made images a little smaller and none made them bigger. Six changes
   later, a stamp. 3 was this file's own first cut, which fitted everything
   INSIDE the board.

   What this does
   --------------
   Two kinds of layer, two rules, both proportional.

   BACKDROP - a layer that covered the whole old board. An image backdrop is
   scaled by ONE factor so it covers the whole new board (max of the two
   ratios) and centred; whatever overhangs is off the board, which is how a
   photo behaves on any size. That is report 3: a template that came in as one
   image is a backdrop, so it fills the size chosen. A solid-colour backdrop
   shape is simply set to the board - flat colour has no proportions to lose.

   CONTENT - everything else: text, photos, panels. Its bounding box is scaled
   by ONE factor to fit inside the board (bar a small margin) and centred, so
   nothing is distorted and nothing is cut off.

   Both rules depend only on the new board, not on how the size got there, so
   nothing drifts: 8x8 -> 10x3 -> 8x8 lands back where it started and repeating
   a size is a no-op. Scale carries through position, size, type size, corner
   radius and stroke together.

   Edge stripes are a third, small case: a SHAPE that runs the full width AND
   sits on the top or bottom edge (or full height on the left or right) is
   stretched to the new board's full width and pinned to that edge. Both
   halves of that test matter - an earlier build asked only "is it as wide as
   the board" and caught mid-board plates, which then drifted off the bottom
   over successive changes. A stripe has to be ON an edge to be a stripe.

   A text layer is never a backdrop and never a stripe, whatever it spans.

   Scope: custom-vinyl-banners only, per the request. Every other product falls
   through to the original hook, unchanged. Widening it is one line - HANDLES.
   sb-dc-tplfix.js asks __dcRefitInScope(handle) before it leans on this for
   the template deep link, so the scope lives in one place.

   2026-09-08 (V0.1.0, 2단계) — 스티커 네 가지를 HANDLES 에 넣었다. 오벌 6x4 를
   8x4 로 바꾸면 옛 훅이 가로만 1.33배 늘려 축구공이 1.82×1.52 로 찌그러졌다
   (헤드리스 크롬 실측). 이 파일의 규칙이면 판 전체를 덮는 타원 배경·키라인은
   kind 3(shape backdrop) 으로 판 크기가 되고, 공·글자는 한 배율로 안에 맞는다.
   단 «같은 비율» 로 바꿀 때(원형 3x3→5x5, 오벌 6x4→3x2)는 ZOOM: 옛 훅에 넘긴다 —
   sx = sy 라 옛 훅이 곧 «그대로 확대» 이고, 이 파일의 content 규칙은 여백 기준으로
   다시 앉혀 구도를 바꾸기 때문이다. 비닐 배너는 예전 동작 그대로(ZOOM 아님).

   Load order: after sb-dc-aug.js, which defines the hook this replaces. */
(function () {
  /* 2026-09-08 3단계: 메시·패브릭 배너도 비닐과 «같은 규칙» (사장님 지시). 8x4→10x3 에서
     마름모·글자가 납작해지던 것 — 같은 디자인이 비닐에서는 비율을 지켰다. */
  /* 2026-09-08 4단계: 스텝앤리핏·팝업 백드롭(반복 벽)은 REPEAT — 비닐 규칙(내용을 한
     덩어리로 가운데 맞춤)을 쓰면 8x8→16x8 에서 패턴이 가운데 모이고 양옆이 빈다.
     대신 변환기(svgToLayers keptShape)가 «열자마자» 하는 것과 같은 셈: 자리(중심)는
     판 비율대로 옮기고, 크기는 «짧은 변의 비» min(새 판)/min(옛 판) 하나로. 정사각
     원본은 처음 열 때 크기가 min(W,H) 에 비례하므로 그 크기로 처음 연 것과 같은
     그림이 되고, 상태값의 비라서 되돌리면 정확히 제자리다. (처음엔 min(sx,sy) 로
     했더니 16x8→8x8 에서 절반으로 줄어 왕복이 안 맞았다.) 로고·원·글자는 모양을
     지키고 간격만 벌어지거나 좁아진다. */
  var REPEAT = ['custom-step-and-repeat-banner', 'fabric-step-repeat-banners', 'vinyl-step-and-repeat-banner',
                'fabric-step-and-repeat-banner', '10x8-fabric-pop-up-display-backdrop-banner-only',
                /* 2026-09-18: 8x8 팝업도 같은 갈래로. 벽지 복사를 뺀 뒤 8x8 만 맨 아래 옛 훅(x·width 만 sx 로
                   눌리고 사진은 왕복할수록 작아짐)으로 가지 않도록 한다. */
                '8x8-fabric-pop-up-display-backdrop-banner-only'];
  /* 2026-09-08 V0.1.1: 배너 3종은 BANNER — 갈래를 셋으로 나눴다(사장님: «필요하면 따로따로»).
     배너 = refitBanner(가운데 묶음 + 양옆 장식), 스티커 = refitSide(예전 그대로), 반복 벽 = refitRepeat. */
  var BANNER = ['custom-vinyl-banners', 'mesh-banners', 'fabric-banners'];
  var HANDLES = BANNER.concat(['bumper-stickers', 'round-stickers', 'oval-stickers', 'kiss-cut-stickers']).concat(REPEAT);
  var ZOOM = ['bumper-stickers', 'round-stickers', 'oval-stickers', 'kiss-cut-stickers'];   // 같은 비율이면 그대로 확대
  var SCALARS = ['fontSizeIn', 'cornerRadiusIn', 'strokeWidthIn', 'fitMaxIn'];
  var EDGE = 0.02;       /* within 2% of a board edge counts as touching it */
  var BACKDROP = 0.06;   /* an image within 6% of every edge is a backdrop */
  var MARGIN_IN = 1;     /* keep content out of the finishing edge */
  var MARGIN_MAX = 0.03; /* ... but never more than 3% of the short side */
  var tries = 0;

  function handleOf(next) {
    try {
      return (next && next.spec && next.spec.__dcProd) ||
             (window.__dcAppliedProduct && window.__dcAppliedProduct() || {}).handle || '';
    } catch (e) { return ''; }
  }
  function inScope(next) { return HANDLES.indexOf(handleOf(next)) !== -1; }

  window.__dcRefitInScope = function (handle) {
    if (handle) return HANDLES.indexOf(handle) !== -1;
    return inScope(null);
  };
  // 반복 벽인가 — sb-dc-tplfix.js 가 «열자마자» 는 예전 그대로(직접 build) 두려고 묻는다
  window.__dcRefitRepeat = function (handle) { return REPEAT.indexOf(handle || handleOf(null)) !== -1; };
  window.__dcRefitRepeatSide = refitRepeat;   // sb-dc-steprepeat.js: layers around the logo pattern follow a size change by this rule

  /* 0 content; 1 top/bottom stripe; 2 left/right stripe; 3 shape backdrop;
     4 image backdrop */
  function kindOf(L, ow, oh) {
    if (!L) return 0;
    var x = +L.xIn || 0, y = +L.yIn || 0;
    var w = +L.widthIn || 0, h = +L.heightIn || 0;
    if (L.type === 'image') {
      var cW = x <= ow * BACKDROP && (x + w) >= ow * (1 - BACKDROP);
      var cH = y <= oh * BACKDROP && (y + h) >= oh * (1 - BACKDROP);
      return (cW && cH) ? 4 : 0;
    }
    if (L.type !== 'shape') return 0;
    var spansW = x <= ow * EDGE && (x + w) >= ow * (1 - EDGE);
    var spansH = y <= oh * EDGE && (y + h) >= oh * (1 - EDGE);
    if (spansW && spansH) return 3;
    if (spansW && (y <= oh * EDGE || (y + h) >= oh * (1 - EDGE))) return 1;
    if (spansH && (x <= ow * EDGE || (x + w) >= ow * (1 - EDGE))) return 2;
    return 0;
  }

  function refitSide(sd, ow, oh, nw, nh) {
    if (!sd || !Array.isArray(sd.layers) || !sd.layers.length) return sd;

    var content = sd.layers.filter(function (L) {
      return L.visible !== false && !kindOf(L, ow, oh);
    });
    if (!content.length) content = sd.layers.slice();

    var x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;
    content.forEach(function (L) {
      var x = +L.xIn || 0, y = +L.yIn || 0;
      var w = +L.widthIn || 0, h = +L.heightIn || 0;
      if (x < x0) x0 = x;
      if (y < y0) y0 = y;
      if (x + w > x1) x1 = x + w;
      if (y + h > y1) y1 = y + h;
    });
    var bw = x1 - x0, bh = y1 - y0;
    if (!(bw > 0 && bh > 0 && isFinite(bw) && isFinite(bh))) return sd;

    var m = Math.min(MARGIN_IN, MARGIN_MAX * Math.min(nw, nh));
    var aw = Math.max(nw - 2 * m, 1), ah = Math.max(nh - 2 * m, 1);
    var s = Math.min(aw / bw, ah / bh);
    if (!(s > 0 && isFinite(s))) return sd;
    var offX = (nw - bw * s) / 2 - x0 * s;
    var offY = (nh - bh * s) / 2 - y0 * s;

    var out = {};
    for (var k in sd) out[k] = sd[k];

    out.layers = sd.layers.map(function (L) {
      var o = {}, i, sc;
      for (var key in L) o[key] = L[key];

      var x = +L.xIn || 0, y = +L.yIn || 0;
      var w = +L.widthIn || 0, h = +L.heightIn || 0;
      var kind = kindOf(L, ow, oh);

      if (kind === 4) {
        /* image backdrop: cover the board, centred, overhang off the board */
        sc = Math.max(nw / w, nh / h);
        o.widthIn = w * sc;
        o.heightIn = h * sc;
        o.xIn = (nw - o.widthIn) / 2;
        o.yIn = (nh - o.heightIn) / 2;
        for (i = 0; i < SCALARS.length; i++) {
          if (typeof L[SCALARS[i]] === 'number') o[SCALARS[i]] = L[SCALARS[i]] * sc;
        }
        return o;
      }

      o.xIn = x * s + offX;
      o.yIn = y * s + offY;
      o.widthIn = w * s;
      o.heightIn = h * s;
      for (i = 0; i < SCALARS.length; i++) {
        if (typeof L[SCALARS[i]] === 'number') o[SCALARS[i]] = L[SCALARS[i]] * s;
      }

      if (kind === 1) {
        o.xIn = 0;
        o.widthIn = nw;
        o.yIn = (y <= oh * EDGE) ? 0 : nh - o.heightIn;
      } else if (kind === 2) {
        o.yIn = 0;
        o.heightIn = nh;
        o.xIn = (x <= ow * EDGE) ? 0 : nw - o.widthIn;
      } else if (kind === 3) {
        o.xIn = 0; o.yIn = 0;
        o.widthIn = nw; o.heightIn = nh;
      }
      return o;
    });

    return out;
  }

  /* 배너(비닐·메시·패브릭) — 새 규격(배경 한 장 + 가운데 글자 묶음 + 양옆 장식) 기준. V0.1.1
     198장 전수 시험(2026-09-08 밤) 뒤 정리한 규칙:
     · 배경(kind 3/4)은 판을 채운다(그림은 비율 유지·잘라냄).
     · 받침 = 직사각형 도형이 판 가장자리 두 곳 이상에 닿은 것(옆 판, 위아래 띠, 가운데 리본, 모서리 블록).
       띠(좌우 닿음)는 폭 = 판, 두께는 sy 배, 위/아래에 붙었으면 그 자리에 고정. 옆 판(상하 닿음)은 높이 = 판,
       폭은 sx 배. 모서리 블록은 (sx, sy). 받침 «위에 있던» 글자·상자는 그 받침을 따라간다: 받침 안에서
       한 묶음으로 비율 자리·한 배율(받침의 sx, sy 중 작은 쪽) — 띠 위 글자가 8x8 에서 띠를 벗어나던 것.
     · 판 무늬 = 그 밖에 가장자리 두 곳 이상에 닿는 도형(사선 띠, 마름모 등) → (sx, sy) 로 늘림.
     · 나머지 = 빈 영역(판에서 가장자리에 붙은 받침을 뺀 직사각형)에 맞춘다. 글자 + 글자 상자와 겹치는 것이
       가운데 묶음(한 배율, 여백 가로 6%·세로 8%), 그 밖(하트 등)은 장식: 같은 배율, 자리는 빈 영역 비율 자리,
       묶음과 겹치면 바깥쪽으로.
     · 모두 «새 판만» 보고 정하므로 몇 번을 바꿔도 누적이 없다. */
  var MX = 0.06, MY = 0.08;
  function bxOf(L) { return { x: +L.xIn || 0, y: +L.yIn || 0, w: +L.widthIn || 0, h: +L.heightIn || 0 }; }
  function unionOf(ls) {
    var x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;
    ls.forEach(function (L) { var b = bxOf(L); x0 = Math.min(x0, b.x); y0 = Math.min(y0, b.y); x1 = Math.max(x1, b.x + b.w); y1 = Math.max(y1, b.y + b.h); });
    return { x: x0, y: y0, w: x1 - x0, h: y1 - y0 };
  }
  function overlaps(a, b) { return a.x < b.x + b.w && b.x < a.x + a.w && a.y < b.y + b.h && b.y < a.y + a.h; }
  function edgesOf(b, ow, oh) {
    return { l: b.x <= ow * EDGE, r: b.x + b.w >= ow * (1 - EDGE), t: b.y <= oh * EDGE, b: b.y + b.h >= oh * (1 - EDGE) };
  }
  function edgeCount(e) { return (e.l ? 1 : 0) + (e.r ? 1 : 0) + (e.t ? 1 : 0) + (e.b ? 1 : 0); }
  function isPattern(L, ow, oh) {
    if (!L || L.type === 'text' || L.type === 'image') return false;
    return edgeCount(edgesOf(bxOf(L), ow, oh)) >= 2;
  }
  function isCarrier(L, ow, oh) {
    if (!isPattern(L, ow, oh) || L.type !== 'shape' || L.visible === false) return false;
    if (L.shape === 'rect' || !L.shape) return true;                       // 직사각형: 두 곳
    /* 사선 옆 판(path·polygon): 세 곳. 마름모·별·타원은 제외 — 사선 무늬의 첫/끝 마름모가 판 옆에 닿아
       «옆 판» 으로 잡히면 빈 영역이 가운데 1/3 로 줄어 글자가 0.49 배가 되었다(5K 시험 파일). */
    if (L.shape !== 'path' && L.shape !== 'polygon') return false;
    return edgeCount(edgesOf(bxOf(L), ow, oh)) >= 3;
  }
  /* 묶음 ls 를 옛 상자 c 에서 새 상자 n 으로: 한 배율(작은 쪽), 중심은 비율 자리, 안에 들어가게 당김 */
  function placeIn(ls, c, n, outOf, scalarsOf) {
    if (!ls.length) return;
    var g = unionOf(ls);
    /* 배율: 받침의 안전 영역(가로 6%·세로 8% 여백)을 채우되, 받침 넓이 배율 √(rsx·rsy) 를 넘지 않는다.
       채우기만 쓰면 띠 위 작은 글자가 8x8 에서 띠만큼 커지고, 작은 쪽 배율만 쓰면 옆 판 글자가 10x3→8x4 에서
       0.8 로 줄어 사진보다 작아 보인다. 넓이 배율은 ELECT 8x4 에서 1.03(원본 크기 유지), 띠 8x8 에서 1.41. */
    /* 채우기 목표 = 안전 영역(88%·84%)과 «원본에서 차지하던 비율» 중 큰 쪽 — 원본이 더 넓게 썼다면 그대로 둔다.
       그래야 원본 판으로 돌아왔을 때 배율이 정확히 1 이다. */
    var fw = Math.max(g.w / (c.w || 1), 1 - 2 * MX), fh = Math.max(g.h / (c.h || 1), 1 - 2 * MY);
    var fill = Math.min(n.w * fw / (g.w || 1), n.h * fh / (g.h || 1));
    var cs = Math.min(fill, Math.sqrt((n.w / c.w) * (n.h / c.h)));
    if (!(cs > 0 && isFinite(cs))) cs = 1;
    var gw = g.w * cs, gh = g.h * cs;
    var cx = n.x + ((g.x + g.w / 2 - c.x) / (c.w || 1)) * n.w, cy = n.y + ((g.y + g.h / 2 - c.y) / (c.h || 1)) * n.h;
    var x0 = Math.max(n.x, Math.min(n.x + n.w - gw, cx - gw / 2)), y0 = Math.max(n.y, Math.min(n.y + n.h - gh, cy - gh / 2));
    if (gw > n.w) x0 = n.x + (n.w - gw) / 2;
    if (gh > n.h) y0 = n.y + (n.h - gh) / 2;
    ls.forEach(function (L) {
      var b = bxOf(L), o = outOf(L);
      o.xIn = x0 + (b.x - g.x) * cs; o.yIn = y0 + (b.y - g.y) * cs; o.widthIn = b.w * cs; o.heightIn = b.h * cs;
      scalarsOf(L, o, cs);
    });
  }
  function refitBanner(sd, ow, oh, nw, nh) {
    if (!sd || !Array.isArray(sd.layers) || !sd.layers.length) return sd;
    var sx = nw / ow, sy = nh / oh, sm = Math.min(sx, sy);
    var out = {};
    for (var k in sd) out[k] = sd[k];
    var outL = sd.layers.map(function (L) { var o = {}; for (var key in L) o[key] = L[key]; return o; });
    function outOf(L) { return outL[sd.layers.indexOf(L)]; }   // 원본 레이어에 표시를 남기지 않는다
    function scalars(L, o, sc) { for (var i = 0; i < SCALARS.length; i++) if (typeof L[SCALARS[i]] === 'number') o[SCALARS[i]] = L[SCALARS[i]] * sc; }
    var carriers = [], content = [], freeOld = { x: 0, y: 0, w: ow, h: oh }, freeNew = { x: 0, y: 0, w: nw, h: nh };
    var fx0 = 0, fx1 = ow, fy0 = 0, fy1 = oh, nx0 = 0, nx1 = nw, ny0 = 0, ny1 = nh;

    sd.layers.forEach(function (L) {
      var o = outOf(L), b = bxOf(L), kind = kindOf(L, ow, oh), sc;
      if (kind === 4) {
        sc = Math.max(nw / b.w, nh / b.h);
        o.widthIn = b.w * sc; o.heightIn = b.h * sc; o.xIn = (nw - o.widthIn) / 2; o.yIn = (nh - o.heightIn) / 2;
        scalars(L, o, sc); return;
      }
      if (kind === 3) { o.xIn = 0; o.yIn = 0; o.widthIn = nw; o.heightIn = nh; scalars(L, o, sm); return; }
      if (isCarrier(L, ow, oh)) {
        var e = edgesOf(b, ow, oh), n;
        if (e.l && e.r) {                                   // 띠 (위/아래 붙음) 또는 가운데 리본
          n = { x: 0, w: nw, h: b.h * sy, mid: !e.t && !e.b };
          n.y = e.t ? 0 : e.b ? nh - n.h : (b.y + b.h / 2) * sy - n.h / 2;
          if (e.t && !e.b) { fy0 = Math.max(fy0, b.y + b.h); ny0 = Math.max(ny0, n.y + n.h); }
          if (e.b && !e.t) { fy1 = Math.min(fy1, b.y); ny1 = Math.min(ny1, n.y); }
        } else if (e.t && e.b) {                            // 옆 판 (좌/우 붙음) 또는 가운데 세로 판
          n = { y: 0, h: nh, w: b.w * sx, midV: !e.l && !e.r };
          n.x = e.l ? 0 : e.r ? nw - n.w : (b.x + b.w / 2) * sx - n.w / 2;
          if (e.l && !e.r) { fx0 = Math.max(fx0, b.x + b.w); nx0 = Math.max(nx0, n.x + n.w); }
          if (e.r && !e.l) { fx1 = Math.min(fx1, b.x); nx1 = Math.min(nx1, n.x); }
        } else {                                            // 모서리 블록
          n = { x: b.x * sx, y: b.y * sy, w: b.w * sx, h: b.h * sy };
        }
        o.xIn = n.x; o.yIn = n.y; o.widthIn = n.w; o.heightIn = n.h; scalars(L, o, sm);
        carriers.push({ L: L, old: b, nu: n, items: [] });
        return;
      }
      if (isPattern(L, ow, oh)) {
        o.xIn = b.x * sx; o.yIn = b.y * sy; o.widthIn = b.w * sx; o.heightIn = b.h * sy; scalars(L, o, sm); return;
      }
      if (L.visible === false) { o.xIn = b.x * sx; o.yIn = b.y * sy; o.widthIn = b.w * sm; o.heightIn = b.h * sm; scalars(L, o, sm); return; }
      content.push(L);
    });
    if (fx1 - fx0 > ow * 0.2 && fy1 - fy0 > oh * 0.2 && nx1 - nx0 > 1 && ny1 - ny0 > 1) {
      freeOld = { x: fx0, y: fy0, w: fx1 - fx0, h: fy1 - fy0 }; freeNew = { x: nx0, y: ny0, w: nx1 - nx0, h: ny1 - ny0 };
    }

    /* 받침 위의 것은 받침을 따라간다 (여러 받침이 겹치면 가장 작은 것) */
    var free = [];
    content.forEach(function (L) {
      var b = bxOf(L), cx = b.x + b.w / 2, cy = b.y + b.h / 2, best = null;
      carriers.forEach(function (c) {
        var o = c.old;
        if (cx >= o.x && cx <= o.x + o.w && cy >= o.y && cy <= o.y + o.h && (!best || o.w * o.h < best.old.w * best.old.h)) best = c;
      });
      if (best) best.items.push(L); else free.push(L);
    });
    /* 빈 영역: 가운데 묶음 + 장식. 가운데 리본(위아래 안 붙은 띠)은 묶음의 일부로 재서 묶음을 따라간다 —
       2x3 에서 리본이 위아래 글자와 겹치고 8x8 에서 리본 글자만 작게 남던 것. */
    var mids = carriers.filter(function (c) { return c.nu.mid || c.nu.midV; });
    if (free.length) {
      var texts = free.filter(function (L) { return L.type === 'text'; });
      var core = texts.length ? texts : free;
      var tb = unionOf(core), group = [], deco = [];
      free.forEach(function (L) { (core.indexOf(L) !== -1 || overlaps(bxOf(L), tb)) ? group.push(L) : deco.push(L); });
      var gb = unionOf(group.concat(mids.map(function (c) { return c.L; }))), gcx = gb.x + gb.w / 2, gcy = gb.y + gb.h / 2;
      var sideW = 0, sideH = 0, sideOf = [];
      deco.forEach(function (L, i) {
        var b = bxOf(L), dx = Math.abs(b.x + b.w / 2 - gcx) / ow, dy = Math.abs(b.y + b.h / 2 - gcy) / oh;
        sideOf[i] = dx >= dy ? 'x' : 'y';
        if (sideOf[i] === 'x') sideW = Math.max(sideW, b.w); else sideH = Math.max(sideH, b.h);
      });
      /* 배율 = min(빈 영역 넓이 배율 √(rsx·rsy), 빈 영역에 맞는 배율). 맞는 배율의 목표는 안전 영역(88%·84%)과
         «원본에서 차지하던 비율» 중 큰 쪽이라 원본 판에서는 정확히 1 — 여러 번 바꿔도 처음 크기로 돌아온다.
         (안전 영역만 쓰면 글자가 판의 94% 를 쓰던 디자인이 돌아올 때마다 7% 작게 남았다 — 198장 중 139장.) */
      var needW = gb.w + 2 * sideW * 1.2, needH = gb.h + 2 * sideH * 1.2;
      var fw = Math.max(needW / freeOld.w, 1 - 2 * MX), fh = Math.max(needH / freeOld.h, 1 - 2 * MY);
      var s = Math.min(freeNew.w * fw / needW, freeNew.h * fh / needH,
                       Math.sqrt((freeNew.w / freeOld.w) * (freeNew.h / freeOld.h)));
      if (!(s > 0 && isFinite(s))) s = sm;
      /* 자리: 빈 영역 안에서의 비율 자리(원본에서 왼쪽 위에 있었으면 계속 왼쪽 위) — 가운데로 몰면 원본으로
         돌아와도 자리가 달라진다(198장 중 77장). 영역 밖이면 안으로 당긴다. */
      var ng = { w: gb.w * s, h: gb.h * s };
      ng.x = freeNew.x + ((gb.x + gb.w / 2 - freeOld.x) / freeOld.w) * freeNew.w - ng.w / 2;
      ng.y = freeNew.y + ((gb.y + gb.h / 2 - freeOld.y) / freeOld.h) * freeNew.h - ng.h / 2;
      ng.x = Math.max(freeNew.x, Math.min(freeNew.x + freeNew.w - ng.w, ng.x));
      ng.y = Math.max(freeNew.y, Math.min(freeNew.y + freeNew.h - ng.h, ng.y));
      if (ng.w > freeNew.w) ng.x = freeNew.x + (freeNew.w - ng.w) / 2;
      if (ng.h > freeNew.h) ng.y = freeNew.y + (freeNew.h - ng.h) / 2;
      mids.forEach(function (c) {
        var b = c.old, o = outOf(c.L), n = c.nu;
        if (n.mid) { n.y = ng.y + (b.y - gb.y) * s; n.h = b.h * s; }
        else { n.x = ng.x + (b.x - gb.x) * s; n.w = b.w * s; }
        o.xIn = n.x; o.yIn = n.y; o.widthIn = n.w; o.heightIn = n.h; scalars(c.L, o, s);
      });
      group.forEach(function (L) {
        var b = bxOf(L), o = outOf(L);
        o.xIn = ng.x + (b.x - gb.x) * s; o.yIn = ng.y + (b.y - gb.y) * s; o.widthIn = b.w * s; o.heightIn = b.h * s; scalars(L, o, s);
      });
      deco.forEach(function (L, i) {
        var b = bxOf(L), o = outOf(L);
        o.widthIn = b.w * s; o.heightIn = b.h * s;
        var cx = freeNew.x + (b.x + b.w / 2 - freeOld.x) / freeOld.w * freeNew.w;
        var cy = freeNew.y + (b.y + b.h / 2 - freeOld.y) / freeOld.h * freeNew.h, gap = 0.5 * s;
        if (sideOf[i] === 'x') {
          if (cx < ng.x + ng.w / 2) cx = Math.min(cx, ng.x - gap - o.widthIn / 2);
          else cx = Math.max(cx, ng.x + ng.w + gap + o.widthIn / 2);
        } else {
          if (cy < ng.y + ng.h / 2) cy = Math.min(cy, ng.y - gap - o.heightIn / 2);
          else cy = Math.max(cy, ng.y + ng.h + gap + o.heightIn / 2);
        }
        o.xIn = Math.max(freeNew.x, Math.min(freeNew.x + freeNew.w - o.widthIn, cx - o.widthIn / 2));
        o.yIn = Math.max(freeNew.y, Math.min(freeNew.y + freeNew.h - o.heightIn, cy - o.heightIn / 2));
        scalars(L, o, s);
      });
    }
    carriers.forEach(function (c) { placeIn(c.items, c.old, c.nu, outOf, scalars); });
    out.layers = outL;
    return out;
  }

  /* 반복 벽: 중심은 (sx, sy), 크기는 min(nw,nh)/min(ow,oh). 판 전체 배경·가장자리 띠는 refitSide 와 같은 규칙. */
  function refitRepeat(sd, ow, oh, nw, nh) {
    if (!sd || !Array.isArray(sd.layers) || !sd.layers.length) return sd;
    var sx = nw / ow, sy = nh / oh, sm = Math.min(nw, nh) / Math.min(ow, oh);
    var out = {};
    for (var k in sd) out[k] = sd[k];
    out.layers = sd.layers.map(function (L) {
      var o = {}, i, sc = sm;
      for (var key in L) o[key] = L[key];
      var x = +L.xIn || 0, y = +L.yIn || 0;
      var w = +L.widthIn || 0, h = +L.heightIn || 0;
      var kind = kindOf(L, ow, oh);
      if (kind === 4) {
        sc = Math.max(nw / w, nh / h);
        o.widthIn = w * sc; o.heightIn = h * sc;
        o.xIn = (nw - o.widthIn) / 2; o.yIn = (nh - o.heightIn) / 2;
      } else {
        o.widthIn = w * sm; o.heightIn = h * sm;
        o.xIn = (x + w / 2) * sx - o.widthIn / 2;
        o.yIn = (y + h / 2) * sy - o.heightIn / 2;
        if (kind === 1) { o.xIn = 0; o.widthIn = nw; o.yIn = (y <= oh * EDGE) ? 0 : nh - o.heightIn; }
        else if (kind === 2) { o.yIn = 0; o.heightIn = nh; o.xIn = (x <= ow * EDGE) ? 0 : nw - o.widthIn; }
        else if (kind === 3) { o.xIn = 0; o.yIn = 0; o.widthIn = nw; o.heightIn = nh; }
      }
      for (i = 0; i < SCALARS.length; i++) {
        if (typeof L[SCALARS[i]] === 'number') o[SCALARS[i]] = L[SCALARS[i]] * sc;
      }
      return o;
    });
    return out;
  }

  /* 원본 기억 — 배너 갈래. 사장님 보고(2026-09-08 밤): 8x4 → 8x8 → 10x3 처럼 여러 번 바꾸면 옆 판 글자가
     갈수록 작아졌다(작은 쪽 배율이 곱해짐: 1 × 0.375). 그래서 배너는 «처음 본 상태»(템플릿이면 그림 원본 판)를
     side.dcRefitBase 에 적어 두고 늘 거기서 새 판으로 계산한다. 마지막으로 내보낸 자리(dcRefitLast)와 지금 자리가
     다르면(손님이 옮기거나 새로 넣었거나 글자를 고쳤으면) 지금 상태를 새 원본으로 삼는다. */
  var GEO = ['xIn', 'yIn', 'widthIn', 'heightIn'].concat(SCALARS);
  function copyOf(L) { var o = {}; for (var k in L) o[k] = L[k]; return o; }
  /* 원본 기억은 refitBanner 가 읽는 값만 — 사진 데이터·글자 내용은 빼서 주문 때 올리는 설계 JSON(9.5MB 캡)이
     두 배로 불지 않게 한다. (2026-09-09 검토: 레이어를 통째로 복사하면 손님 사진이 두 번 실렸다) */
  var KEEP = ['id', 'type', 'shape', 'visible'].concat(GEO);
  function slimOf(L) { var o = {}; for (var i = 0; i < KEEP.length; i++) if (L[KEEP[i]] !== undefined) o[KEEP[i]] = L[KEEP[i]]; return o; }
  function boxKey(L) { return [+L.xIn || 0, +L.yIn || 0, +L.widthIn || 0, +L.heightIn || 0, L.type === 'text' ? (+L.fontSizeIn || 0) : 0]; }
  function unchanged(sd, ow, oh) {
    var last = sd.dcRefitLast, base = sd.dcRefitBase;
    if (!last || !base || !Array.isArray(base.layers)) return false;
    if (Math.abs(last.w - ow) > 1e-6 || Math.abs(last.h - oh) > 1e-6) return false;
    var ids = Object.keys(last.boxes || {});
    if (ids.length !== sd.layers.length) return false;
    for (var i = 0; i < sd.layers.length; i++) {
      var L = sd.layers[i], b = last.boxes[L.id];
      if (!b) return false;
      var k = boxKey(L), tol = L.type === 'text' ? 0.5 : 0.05;     // 글자는 편집기가 다시 재서 폭이 조금 바뀔 수 있다
      if (Math.abs(k[0] - b[0]) > tol || Math.abs(k[1] - b[1]) > tol) return false;
      if (L.type !== 'text' && (Math.abs(k[2] - b[2]) > tol || Math.abs(k[3] - b[3]) > tol)) return false;
      if (L.type === 'text' && Math.abs(k[4] - b[4]) > Math.max(0.02, b[4] * 0.02)) return false;
    }
    return true;
  }
  function withBase(sd, ow, oh, nw, nh, fn) {
    if (!sd || !Array.isArray(sd.layers) || !sd.layers.length) return sd;
    var base = unchanged(sd, ow, oh) ? sd.dcRefitBase
                                     : { w: ow, h: oh, layers: sd.layers.map(slimOf) };
    var res = fn({ layers: base.layers.map(copyOf) }, base.w, base.h, nw, nh);
    var byId = {};
    (res && res.layers || []).forEach(function (L) { byId[L.id] = L; });
    var out = copyOf(sd), boxes = {};
    out.layers = sd.layers.map(function (L) {
      var o = copyOf(L), r = byId[L.id];
      if (r) for (var i = 0; i < GEO.length; i++) if (typeof r[GEO[i]] === 'number') o[GEO[i]] = r[GEO[i]];
      boxes[L.id] = boxKey(o);
      return o;
    });
    out.dcRefitBase = base;
    out.dcRefitLast = { w: nw, h: nh, boxes: boxes };
    return out;
  }

  function install() {
    if (window.__dcRefitFit) return true;
    var orig = window.__dcRefit;
    if (typeof orig !== 'function') return false;

    window.__dcRefit = function (prev, next) {
      try {
        if (!inScope(next)) return orig.apply(this, arguments);

        var ow = prev.spec.widthIn, oh = prev.spec.heightIn;
        var nw = next.spec.widthIn, nh = next.spec.heightIn;
        if (!(ow > 0 && oh > 0 && nw > 0 && nh > 0)) return next;
        /* size unchanged (quantity or finishing only) - hand back the original
           object so nothing is re-rendered or pushed onto the history */
        if (Math.abs(ow - nw) < 1e-6 && Math.abs(oh - nh) < 1e-6) return next;
        /* 스티커, 같은 비율: 옛 훅 = 그대로 확대(sx = sy). 구도가 안 바뀐다. */
        if (ZOOM.indexOf(handleOf(next)) !== -1 && Math.abs(nw / nh - ow / oh) < 1e-6) return orig.apply(this, arguments);

        var hasLayers = (next.front && next.front.layers && next.front.layers.length) ||
                        (next.back && next.back.layers && next.back.layers.length);
        if (!hasLayers) return next;

        var out = {};
        for (var k in next) out[k] = next[k];
        var h = handleOf(next);
        var side = REPEAT.indexOf(h) !== -1 ? refitRepeat
                 : BANNER.indexOf(h) !== -1 ? function (sd, a, b, c, d) { return withBase(sd, a, b, c, d, refitBanner); }
                 : refitSide;
        out.front = side(next.front, ow, oh, nw, nh);
        out.back = next.back ? side(next.back, ow, oh, nw, nh) : next.back;
        return out;
      } catch (e) {
        /* never lose the customer's design to a refit bug */
        try { return orig.apply(this, arguments); } catch (e2) { return next; }
      }
    };

    window.__dcRefitFit = 3;
    return true;
  }

  if (!install()) {
    var t = setInterval(function () {
      if (install() || ++tries > 100) clearInterval(t);
    }, 200);
  }
})();
